export default {"src":"/_next/static/media/googledrive.bb302fab.svg","height":48,"width":112,"blurWidth":0,"blurHeight":0};